import './styles/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { i18n, setLocale } from './i18n'
import { createPersistPlugin, migrateLegacyVuex } from './services/persist/pinia-idb'
import { useSettingsStore } from './stores/settings'
import { useEventsStore } from './stores/events'
import { useTicketsStore } from './stores/tickets'
import { useQueueStore } from './stores/queue'

async function bootstrap() {
    const app = createApp(App)
    const pinia = createPinia()

    const PERSIST_IDS = ['settings', 'events', 'tickets', 'queue', 'auth'] as const
    pinia.use(createPersistPlugin({ ids: PERSIST_IDS }))

    app.use(pinia)
    app.use(router)
    app.use(i18n)

    // Legacy localStorage migration (one-shot)
    const legacy = await migrateLegacyVuex()
    if (legacy) {
        const settings = useSettingsStore()
        const events = useEventsStore()
        const tickets = useTicketsStore()
        const queue = useQueueStore()
        if (legacy.settings && typeof legacy.settings === 'object') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            settings.$patch(legacy.settings as any)
        }
        if (Array.isArray(legacy.events)) events.events = legacy.events as never
        if (Array.isArray(legacy.zones)) events.zones = legacy.zones as never
        if (Array.isArray(legacy.activeEvents)) events.activeEvents = legacy.activeEvents as never
        if (typeof legacy.activeCheckpoint === 'string' || legacy.activeCheckpoint === null) {
            events.activeCheckpoint = legacy.activeCheckpoint
        }
        if (Array.isArray(legacy.activeZones)) events.activeZones = legacy.activeZones as never
        if (Array.isArray(legacy.tickets)) tickets.tickets = legacy.tickets as never
        if (Array.isArray(legacy.sendQueue)) queue.sendQueue = legacy.sendQueue as never
    }

    // Sync i18n with persisted settings.lang
    const settings = useSettingsStore()
    setLocale(settings.lang)

    app.mount('#app')
}

void bootstrap()
